<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #LOG="{visible,params,close}">
      <RateLog :row="params.row" :close="close" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import {
  getCurrency,
  add,
  getDetails,
  update,
  del,
  ratePut
} from "@/api/finance/currency";

import cTable from "@/base/common/index";
import RateLog from "./rate_log";
export default {
  name: "currency",
  components: {
    cTable,
    RateLog
  },
  data() {
    return {
      methods: {
        list: getCurrency,
        getDetails,
        del,
        add,
        update,
        ratePut
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              if (this.type == "add") {
                data.rate_to_cny = 1;
                data.rate_to_usd = 1;
              } else {
                delete row.create_time;
                delete row.update_time;
              }
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "Currency_name cannot be empty",
                  trigger: "blur"
                }
              ],
              en_title: [
                {
                  required: true,
                  message: "en-Name cannot be empty",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  max: 3,
                  message: "Please enter maximum length 3",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ title: 24 }, { en_title: 24 }, { code: 24 }, { sort: 24 }],
          fields: [
            {
              name: () => this.$t("currencyName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("currencyName");
              }
            },
            {
              name: () => this.$t("currencyEnName"),
              key: "en_title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("currencyEnName");
              }
            },
            {
              name: () => this.$t("currencyCode"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("currencyCode");
              }
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "Input",
              bind: {
                border: true,
                type: "number",
                style: "width:100%"
              },
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              }
            }
          ]
        },
        rate: {
          methods: {
            ok({ row, close }) {
              let data = this.$refs["form"].handleFilterData();
              data.id = row.id;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "Currency_name cannot be empty",
                  trigger: "blur"
                }
              ],
              rate: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("type"),
              key: "type",
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("type");
              },
              options: [
                {
                  label: "RMB",
                  value: "RMB"
                },
                {
                  label: "USD",
                  value: "USD"
                }
              ]
            },
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("rate");
              },
              default: null,
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%"
                }
              }
            }
          ]
        },
        showLog: {
          contentSlot: "LOG",
          config: {
            modalBind: {
              width: 1000,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            },
            modalContentBind: {
              style: {
                height: "600px"
              }
            }
          },
          footer: {
            show: () => false
          }
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 115
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",

          width: 60
        },

        {
          name: () => this.$t("currencyName"),
          key: "title",
          align: "left",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("currencyEnName"),
          key: "en_title",
          align: "left",

          minWidth: 100
        },
        {
          name: () => this.$t("currencyCode"),
          key: "code",

          minWidth: 100
        },
        {
          name: () => this.$t("to_rmb"),
          key: "rate_to_cny",

          minWidth: 100
        },
        {
          name: () => this.$t("to_usd"),
          key: "rate_to_usd",

          minWidth: 100
        },

        {
          name: () => this.$t("createTime"),

          key: "create_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          minWidth: 100
        },
        {
          name: () => this.$t("upTime"),

          key: "update_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          type: "btns",
          width: 240,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 116
            },
            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning"
              },
              id: 118
            },
            {
              name: () => this.$t("rate") + this.$t("record"),
              type: "rateLog",
              fnName: "rateLog",
              bind: {
                type: "error"
              },
              id: 404
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 117
              // bind: {
              //   type: "error"
              // }
            }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            rate({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("rate").setTitle(this.$t("rate"));
                this.getModal("rate").type = "ratePut";
                this.getModal("rate").open(res.payload);
              });
            },
            rateLog({ row }) {
              this.getModal("showLog").open({ row }, function() {
                this.setTitle(row.code + this.$t("rate") + this.$t("record"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  }
};
</script>
